import React from 'react';
import { View } from 'react-native';

import { P } from '../../../components/Typography';
import Spacer from '../../../components/Spacer';
import { FormElementProps } from '../../FormElement';
import { FormElementPlugin } from '../FormElementPlugin';
import FormElementQuestion from './components/FormElementQuestion';
import { FormVideoConfig, validateVideoValue } from './FormVideoPlugin.shared';

// Web build of the element. react-native-vision-camera throws on import here
// ("VisionCamera currently does not work on web"), and default.ts loads every
// plugin on every page, so importing the native file would break the whole app.
// See FormVideoPlugin.native.tsx for the real one.

const FormVideo = <T extends object>({
  element
}: FormElementProps<T, FormVideoConfig>) => (
  <View>
    <FormElementQuestion element={element} />
    <Spacer size={2} />
    <P>
      Recording a video response is only available in the Chloe mobile app.
      Please open this study on your phone to continue.
    </P>
  </View>
);

export const FormVideoPlugin: FormElementPlugin<any, FormVideoConfig> = {
  name: 'Video Response',
  type: 'Video',
  dataTypes: ['jsonb'],
  element: FormVideo as React.FC<FormElementProps<any, FormVideoConfig>>,
  validate: validateVideoValue
};
